export const SHOW_SWIPE_TUTORIAL_KEY = 'showSwipeTutorial';
